import { render, staticRenderFns } from "./NotFoundPlanOrFee.vue?vue&type=template&id=5a029f0c"
import script from "./NotFoundPlanOrFee.vue?vue&type=script&lang=js"
export * from "./NotFoundPlanOrFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports